/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { CONTENT_TARGET_ID, ResizeEventHandler } from 'cio/components/sidebar';
import { inject as service } from '@ember/service';
import SidebarService from 'cio/services/sidebar';

interface SidebarPanelArgs {
  onResize?: (event: ResizeEventHandler) => unknown;
  isOverlay: boolean;
}

export default class SidebarPanel extends Component<SidebarPanelArgs> {
  @service sidebar!: SidebarService;

  readonly contentTargetId = CONTENT_TARGET_ID;
}
